module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5Wchg"))).then(() => module.bundle.root('f4eak'));